export default __webpack_public_path__ + "static/media/prayer-background.a5ab4f43.PNG";